import React from "react";
import DatePicker from "react-date-picker";
import calendarLight from "../../images/icons/calendar-light.png";
import calendarDark from "../../images/icons/calendar-dark.png";
import {getCustomerSlotDetails} from "../../services/SessionStorage";
import "./CustomDatePicker.scss";
import moment from "moment";

const CustomDatePicker = ({
  onChange,
  value,
  title,
  className = "",
  locale = "es-AR",
  format = "dd-MM-yyyy",
  maxDate = undefined,
  minDate = undefined,
  minDetail = "decade",
  disabledDatesList = [],
  disabled = false,
}) => {
  const formatWeekDay = (locale, date) => {
    const dateObj = new Date(date);
    return dateObj
      ?.toLocaleDateString(locale, {weekday: "long"})
      ?.substring(0, 1)
      ?.toUpperCase();
  };
  const disableParticularDay = ({activeStartDate, date, view}) => {
    if (disabledDatesList.includes(moment(date).format("DD-MM-YYYY"))) {
      return true;
    } else {
      return false;
    }
  };

  const customerSlotDetails = getCustomerSlotDetails();
  const theme = customerSlotDetails.theme;
  return (
    <React.Fragment>
      <div className="custom-date-wrapper">
        {title ? <div className="custom-date-title">{title}</div> : ""}
        <DatePicker
          onChange={onChange}
          value={value}
          calendarIcon={
            theme === "msteams-dark" || theme === "msteams-contrast" ? (
              <img src={calendarLight} alt="down" />
            ) : (
              <img src={calendarDark} alt="down" />
            )
          }
          className={`custom-date ${className}`}
          format={format}
          locale={locale}
          minDate={minDate}
          maxDate={maxDate}
          tileDisabled={disableParticularDay}
          minDetail={minDetail}
          dayAriaLabel="Day"
          dayPlaceholder="dd"
          monthPlaceholder="mm"
          yearPlaceholder="yyyy"
          formatShortWeekday={formatWeekDay}
          next2Label={null}
          prev2Label={null}
          clearIcon={null}
          disabled={disabled}
          prevLabel={null}
        />
      </div>
    </React.Fragment>
  );
};

export default CustomDatePicker;
